import { useCallback, useEffect, useState } from 'react';
import { GetAllVendorServiceCategories } from '../../../../../../Services';
import { VendorsTranslationPath } from '../../../I18n/VendorsLocale';
import { showError } from '../../../../../../Helper';
import { useTranslation } from 'react-i18next';

export const useFetchVendorCategories = (id) => {
  const { t } = useTranslation(VendorsTranslationPath);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [vendorId, setVendorId] = useState(id);
  const getAllVendorServiceCategories = useCallback(async () => {
    try {
      setIsLoading(true);
      const { result } = await GetAllVendorServiceCategories({
        pageIndex: 1,
        pageSize: 100,
        vendorId,
      });
      setCategories(result);
    } catch (error) {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  }, [vendorId]);
  useEffect(() => {
    if (!!vendorId) {
      getAllVendorServiceCategories();
    }
  }, [getAllVendorServiceCategories]);
  return {
    categories,
    isLoading,
    setVendorId,
  };
};
